import React from 'react';
import { View } from 'react-native';

import FormDateInput, { FormInputProps } from '../form/FormDateInput';
import { H3, I } from '../Typography';

export type SurveyFormDateInputProps = FormInputProps & {
  title?: string;
  description?: string;
  label?: string;
};

const SurveyFormDateInput: React.FC<SurveyFormDateInputProps> = ({
  title,
  description,
  label,
  ...props
}) => {
  const { name } = props;
  return (
    <View>
      {title && (
        <H3 color='light' padding={1}>
          {title}
        </H3>
      )}
      {description && (
        <I color='light' padding={3}>
          {description}
        </I>
      )}
      {label && (
        <I color='light' padding={1}>
          {label}
        </I>
      )}
      <FormDateInput name={name} showPlaceHolder={true} />
    </View>
  );
};

export default SurveyFormDateInput;
